import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractForm } from '@root/abstract/form';


export enum RegisterConfirmFormField {
    Code = 'code',
}

export interface RegisterConfirmFormModel {
    [RegisterConfirmFormField.Code]: FormControl<string | null>;
}

@Injectable()
export class RegisterConfirmFormService extends AbstractForm<RegisterConfirmFormField, RegisterConfirmFormModel> {
    public createReactiveForm(): FormGroup<RegisterConfirmFormModel> {
        this.build({
            [RegisterConfirmFormField.Code]: new FormControl<string | null>(null, [Validators.required]),
        });

        return this.form;
    }
}
